import { Helmet } from 'react-helmet-async';
import ActivationsKeywordExact from 'src/sections/overview/dashboards/views/activations/keyword/exact';

export default function BrandShieldKeywordsExact() {
  return (
    <>
      <Helmet>
        <title>Keywords (Exact)</title>
      </Helmet>

      <ActivationsKeywordExact />
    </>
  );
}
